import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import './UserList.scss';

const roleColorMap = {
  1: 'role-admin',      // Green for admin
  2: 'role-ytm',        // Yellow for YTM
  3: 'role-repairer',   // Orange for repairer
  4: 'role-user',       // Blue for user
  5: 'role-maintenance' // Purple for maintenance
};

function UserList({ users, selectedUserId, onUserClick }) {
  const { t } = useTranslation();
  const getRoleName = (user) => {
    const roleId = user.role || user.groups?.[0];
    const id = [1, 2, 3, 4, 5].includes(Number(roleId)) ? Number(roleId) : 4;
    return t(`user_role_display_${id}`);
  };

  const getRoleColor = (user) => {
    const roleId = user.role || user.groups?.[0];
    return roleColorMap[roleId] || 'role-user';
  };

  const getUserFullName = (user) => {
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || user.email || t('user_list_unnamed');
  };

  return (
    <div className="user-list">
      {users.map((user) => {
        const isSelected = selectedUserId && user.id === parseInt(selectedUserId);
        return (
          <div
            key={user.id}
            className={`user-card ${isSelected ? 'user-card-selected' : ''}`}
            onClick={() => onUserClick(user)}
          >
            <div className="user-card-content">
              <div className="user-card-left">
                <div className="user-name">{getUserFullName(user)}</div>
                <div className="user-email">{user.email}</div>
              </div>
              <div className={`user-role-badge ${getRoleColor(user)}`}>
                {getRoleName(user)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default memo(UserList);
